import { render } from "./PModal.vue?vue&type=template&id=dc560158&scoped=true"
import script from "./PModal.vue?vue&type=script&lang=js"
export * from "./PModal.vue?vue&type=script&lang=js"

import "./PModal.vue?vue&type=style&index=0&id=dc560158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc560158"]])

export default __exports__